// import { Claim } from '@src/interfaces/RootState';
// import { SET_CLAIM_HISTORY, SET_ACTIVE_CLAIM, SET_CUSTOMER, RESET } from './actions';

import { Contract } from '@src/interfaces/RootState';
import {
    RESET_CONTRACT_STORE,
    SET_ACCOUNT_HOLDER,
    SET_BANK_ACCOUNT,
    SET_CONTRACT_NUMBER,
    SET_CONTRACT_SAVED,
    SET_CUSTOMER,
    SET_PARTNER,
    SET_PRODUCT,
    SET_PROJECT_PROPERTIES,
    SET_SMS_ID,
    SET_ATTRIBUTES,
} from './actions';

const initialState: Contract = {
    customerModel: null,
    accountHolderModel: null,
    bankAccountModel: null,
    partnerModel: null,
    productModel: null,
    contractNumber: null,
    contractSaved: false,
    smsId: null,
    projectProperties: null,
    attributes: null,
};
/**
 * Claim related data
 */
export default function contractReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PARTNER:
            return {
                ...state,
                partnerModel: action.val,
            };
        case SET_PRODUCT:
            return {
                ...state,
                productModel: action.val,
            };
        case SET_BANK_ACCOUNT:
            return {
                ...state,
                bankAccountModel: action.val,
            };
        case SET_ACCOUNT_HOLDER:
            return {
                ...state,
                accountHolderModel: action.val,
            };
        case SET_CUSTOMER:
            return {
                ...state,
                customerModel: action.val,
            };
        case SET_CONTRACT_NUMBER:
            return {
                ...state,
                contractNumber: action.val,
            };
        case SET_CONTRACT_SAVED:
            return {
                ...state,
                contractSaved: true,
            };
        case SET_SMS_ID:
            return {
                ...state,
                smsId: action.val,
            };
        case SET_PROJECT_PROPERTIES:
            return {
                ...state,
                projectProperties: action.val,
            };
        case SET_ATTRIBUTES:
            return {
                ...state,
                attributes: action.val,
            };
        case RESET_CONTRACT_STORE:
            return initialState;
        default:
            return state;
    }
}
